var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21 21v7h-2v-7h-7v-2h7v-7h2v7h7v2zm-10.9 8.9c-5.467-5.468-5.467-14.332 0-19.8 5.468-5.467 14.332-5.467 19.8 0 5.467 5.468 5.467 14.332 0 19.8-5.468 5.467-14.332 5.467-19.8 0zm1.415-1.415c4.686 4.687 12.284 4.687 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97z","fillRule":"evenodd"}));
}

Add.defaultProps = {"height":"40","viewBox":"0 0 40 40","width":"40"};

module.exports = Add;

Add.default = Add;
